import { z } from 'zod';

import { responsiveSchema } from '../../utils';

/** A length and the unit it is in. */
export const numberWithUnitSchema = z.object({
    value: z.coerce.number().default(0),
    unit: z.enum(['px', '%']).default('px'),
});

export const responsiveNumberWithUnitSchema = responsiveSchema(numberWithUnitSchema);

export type NumberWithUnit = z.output<typeof numberWithUnitSchema>;
